"use strict";
const seminarMoreEvents = Array.from(document.querySelectorAll('[data-gs1-seminars-more-events]'));
const documentBody = document.querySelector('body');
if (seminarMoreEvents) {
    seminarMoreEvents.forEach((item) => {
        item.addEventListener("click", (event) => {
            event.preventDefault();
            const documentBlocker = document.createElement('div');
            documentBlocker.classList.add('modal__blocker');
            documentBody.appendChild(documentBlocker);
            const el = event.target;
            (el.getAttribute('href') !== '') ? el.offsetParent.children[2].classList.remove('hidden') : '';
        });
    });
}
const seminarsFilters = document.querySelectorAll('.seminars-filters__form');
const seminarCategoriesForm = document.getElementById("seminarCategory");
const seminarTopicsForm = document.getElementById("seminarTopic");
const seminarsCategories = Array.from(document.querySelectorAll('[data-gs1-seminars-categories]'));
const seminarsTopics = Array.from(document.querySelectorAll('[data-gs1-seminars-topics]'));
if (seminarsFilters) {
    seminarsCategories.forEach((item) => {
        item.addEventListener("click", (event) => {
            seminarCategoriesForm.submit();
        });
    });
    seminarsTopics.forEach((item) => {
        item.addEventListener("click", (event) => {
            seminarTopicsForm.submit();
        });
    });
}
